<template>
  <b-modal
      id="xero-overwrite-data-modal"
      ref="xero-overwrite-data-modal"
      size="lg-size"
      modal-class="modal-xero"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">A timesheet for this period already exists</h2>
      <div class="quickbooks-logo">
        <img
            src="/assets/images/xero-logo-blue.svg"
            alt="Atto"
            class="black-logo"
            width="50"
            height="50"
        >
      </div>
    </div>
    <div class="content-wrapper">
      <p>
        A timesheet for the same period already exists in your Xero account. If you proceed with the export from Atto,
        all timesheet data on your Xero account for this period will be overwritten with data from Atto.
      </p>
      <span v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </span>
    </div>
    <div class="modal-footer">
      <button
          type="reset"
          class="atto-btn cancel"
          data-dismiss="modal"
          @click="close"
      >
        {{ label.get('cancel') }}
      </button>
      <button
          class="atto-btn submit"
          type="submit"
          @click="submit"
      >
        PROCEED
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";

export default {
  name: "XeroOverwriteDataModal",
  props: {
    xeroStartDay: {
      type: String,
      default: ''
    },
    payrollCalendarId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      errorMessage: '',

    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$store.commit('showLoading');
    this.$refs['xero-overwrite-data-modal'].show();
    this.$store.commit('hideLoading');
  },
  methods: {
    submit() {

      var data = {
        date: this.xeroStartDay,
        payroll_calendar_id: this.payrollCalendarId,
        overwrite_data: true
      };
      debugger;
      this.$store.commit('showLoading');
      CompanyService.postTimeseetsToXero(data).then((result) => {

        this.$store.commit('hideLoading');
        if (result.data.queue_is_active) {
          this.$root.$emit('hideXeroOverwriteModal', {
            queueIsActive: true
          });

        } else {
          this.$awn.success(result.data.message);
          this.$root.$emit('hideXeroOverwriteModal');
        }
      }).catch(error => {
        this.$store.commit('hideLoading');
        if (error.response.status === 403) {
          this.$store.commit('xeroHasError403', true);
          this.$root.$emit('showXeroErrors');
        }
        this.errorMessage = error.response.data.error.message;
      });

    },
    close() {
      debugger;
      this.$root.$emit('hideXeroOverwriteModal');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>